import React, { useState } from 'react';
import { FiSave, FiDroplet, FiHash } from 'react-icons/fi';

const AddCategoryModal = ({ show, onClose, onSave, existingCategories = [] }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    color: '#3B82F6', // Default blue color
    sort_order: 0
  });

  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Category name is required';
    } else if (existingCategories.some(cat => cat.name.toLowerCase() === formData.name.toLowerCase())) {
      newErrors.name = 'A category with this name already exists';
    }
    
    if (formData.name.length > 50) {
      newErrors.name = 'Category name must be less than 50 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setSaving(true);
    try {
      await onSave(formData);
      handleClose();
    } catch (error) {
      console.error('Error saving category:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleClose = () => {
    setFormData({
      name: '',
      description: '',
      color: '#3B82F6',
      sort_order: 0
    });
    setErrors({});
    setSaving(false);
    onClose();
  };

  if (!show) return null;

  return (
    <>
      <div className="custom-modal-backdrop" onClick={handleClose}></div>
      <div className="custom-modal add-category-modal">
        <button className="close-btn" onClick={handleClose}>&times;</button>
        <h2><FiHash /> Add New Category</h2>
        
        <form onSubmit={handleSubmit} className="add-modal-form">
          <div className="form-group">
            <label className="form-label">
              <FiHash className="label-icon" />
              Category Name *
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={`form-input ${errors.name ? 'error' : ''}`}
              placeholder="Enter category name"
              maxLength={50}
            />
            {errors.name && <span className="error-message">{errors.name}</span>}
            <small className="form-help">Maximum 50 characters</small>
          </div>

          <div className="form-group">
            <label className="form-label">
              <FiHash className="label-icon" />
              Description
            </label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="form-input form-textarea"
              placeholder="Enter category description (optional)"
              rows="3"
              maxLength={200}
            />
            <small className="form-help">Maximum 200 characters</small>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">
                <FiDroplet className="label-icon" />
                Color
              </label>
              <div className="color-input-group">
                <input
                  type="color"
                  name="color"
                  value={formData.color}
                  onChange={handleChange}
                  className="color-picker"
                />
                <input
                  type="text"
                  name="color"
                  value={formData.color}
                  onChange={handleChange}
                  className="form-input color-text"
                  placeholder="#3B82F6"
                />
              </div>
              <small className="form-help">Choose a color for this category</small>
            </div>

            <div className="form-group">
              <label className="form-label">
                <FiHash className="label-icon" />
                Sort Order
              </label>
              <input
                type="number"
                name="sort_order"
                value={formData.sort_order}
                onChange={handleChange}
                className="form-input"
                placeholder="0"
                min="0"
              />
              <small className="form-help">Lower numbers appear first</small>
            </div>
          </div>

          {/* Form Actions */}
          <div className="modal-actions">
            <button 
              type="button" 
              className="btn btn-cancel" 
              onClick={handleClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={saving}
            >
              <FiSave /> {saving ? 'Saving...' : 'Save Category'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddCategoryModal;
